export default function contentfulDeafultLoader({ src, width, quality = 100 }: { src: string; width: number; quality?: number }) {
  try {
    if (!src.includes(".svg")) {
      const url = new URL(src);
      url.searchParams.set("fm", "webp");
      url.searchParams.set("w", width.toString());
      url.searchParams.set("q", quality.toString());
      url.searchParams.set("fit", "fill");
      return url.href;
    }
    return src;
  } catch (error) {
    console.error(error);
  }
}

export interface ImageTransformOptions {
  src: string;
  width: number; // Larghezza dell'immagine (max 4000px)
  height?: number; // Altezza dell'immagine (max 4000px)
  quality?: number; // Qualità dell'immagine (1-100)
  format?: "jpg" | "png" | "webp" | "gif" | "avif" | "tiff";
  fit?: "pad" | "fill" | "scale" | "crop" | "thumb"; // Tipo di ridimensionamento
  focus?: "center" | "top" | "right" | "left" | "bottom" | "top_right" | "top_left" | "bottom_right" | "bottom_left" | "face" | "faces"; // Area di focus
  cornerRadius?: number | "max"; // Per angoli arrotondati o ellissi
  backgroundColor?: string; // Colore di sfondo (per fit pad o angoli arrotondati)
  progressive?: boolean; // Per immagini JPEG progressive
}
/**
 * https://www.contentful.com/developers/docs/references/images-api/
 * @param
 */
export const contentfulImageLoader = ({
  src,
  width,
  height,
  quality = 100,
  format = "webp",
  fit = "fill",
  focus,
  cornerRadius,
  backgroundColor,
  progressive,
}: ImageTransformOptions) => {
  try {
    const params = new URLSearchParams();
    if (src && !src.includes(".svg")) {
      if (format) params.append("fm", format);
      if (progressive) params.append("fl", "progressive");
    } else {
      params.append("fm", "webp");
    }
    if (width) params.append("w", width.toString());
    if (height) params.append("h", height.toString());
    if (fit) params.append("fit", fit);
    if (focus) params.append("f", focus);
    if (cornerRadius) params.append("r", cornerRadius === "max" ? "max" : cornerRadius.toString());
    if (quality) params.append("q", quality.toString());
    if (backgroundColor) params.append("bg", backgroundColor);
    return `${src}?${params.toString()}`;
  } catch (error) {
    console.error(error);
  }
};
